import { PasswordState } from '@/store/types';

const state: PasswordState = {
  requestError: {
    put: {
      message: '',
    },
  },
  requestSuccess: {
    message: '',
  },
  password: '',
  newPassword: '',
  confirmNewPassword: '',
};

export default state;
